export const DISPLAY_PHONE_NUMBER = "800-377-3962";
export const SUPPORT_PHONE_NUMBER = "+18007251243";
export const SUPPORT_AVAILABLE_TEXT = "Available 24/7";
export const SUPPORT_RELAY_TEXT = "We accept relay calls.";
export const SUPPORT_TALK_TO_REP_TEXT = "Want to talk to a rep now?";
export const USE_COBROWSE_TEXT = "Cobrowse";
export const  USE_COBROWSE_SUBTEXT = "Share your screen securely during a support call."